<template>
    <div class="main">
		<!-- Super Navbar -->
		<super-nav-inventro v-if="isNavVisible"/>

		<main class="main">
			<!-- Alert Carousel -->
			<div class="container" v-if="currentAlert">
				<div :class="['alert', currentAlert.alertClass, 'has-shadow mt-3 d-flex align-items-center justify-content-between']">
					<div class="">
						<div class="">
							<span class="badge bg-light text-dark border">{{ currentAlert.type }}</span>
							<span class="ml-2 text-muted small">{{ currentAlertIndex + 1 }} dari {{ alerts.length }}</span>
						</div>
						<span>{{ currentAlert.message }}</span>
					</div>
					<div class="d-flex align-items-center gap-2 ms-auto">
						<button class="btn btn-primary btn-sm" @click="handleAlertAction(currentAlert)">
							{{ currentAlert.actionLabel }}
						</button>
						<div v-if="alerts.length > 1" class="btn-group ml-2" role="group">
							<button type="button" class="btn btn-outline-dark btn-sm" @click="prevAlert">
								<i class="bi bi-chevron-left"></i>
							</button>
							<button type="button" class="btn btn-outline-dark btn-sm" @click="nextAlert">
								<i class="bi bi-chevron-right"></i>
							</button>
						</div>
					</div>
				</div>
			</div>

			<router-view v-if="isNotAuthorizedPage || !!user"></router-view>

			<div class="page-loader mt-5" v-else>
				<div class="is-loading dark large"></div>
			</div>
			<announcements
				:visible="isRightbarVisible"
				@close="toggleAnnouncements(false)"
				v-if="isRightbarVisible"
			>
			</announcements>
			<ModalPopupInformation v-if="isModalVisible" :config="currentInformation" @close="closeModal" />
		</main>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
// import dayjs from 'dayjs';
import submissionApi from '@/api/submissions';
import Announcements from '@/components/Announcements.vue';
import homepageApi from '@/api/homepage';
import ModalPopupInformation from '@/components/pop-information/ModalPopup.vue';
import {
	duplicateVar,
} from '@/lib/helper';
import {
	setCookie,
	getCookie,
	// removeCookie
} from '@/lib/cookie';

const SuperNavInventro = () => import(
	/* webpackChunkName: "super-nav-ostock" */ '@/components/inventro/SuperNavInventro.vue'
);

const COOKIE_POPUP_CLOSED_IDS = 'popup_closed_ids';

export default {
	name: 'MainLayout',
	components: {
		Announcements,
		SuperNavInventro,
		ModalPopupInformation,
	},
	data() {
		return {
			informations: [],
			currentInformation: null,
			currentInformationIndex: null,
			isModalVisible: false,
			currentAlertIndex: 0,
			alerts: [],
		};
	},
	computed: {
		...mapGetters({
			user: 'user',
			isOwner: 'isOwner',
			settings: 'settings',
			isLoggedIn: 'isLoggedIn',
			isSupplier: 'isSupplier',
			isDropshipper: 'isDropshipper',
			isRoleAdmin: 'isRoleAdmin',
			isHasUsername: 'isHasUsername',
			isHasBankAccounts: 'isHasBankAccounts',
			isRightbarVisible: 'isRightbarVisible',
			notice: 'notice',
			billingsCount: 'billingsCount',
			billingsDueCount: 'billingsDueCount',
			limitedStockProductIds: 'limitedStockProductIds',
			rangeStockCheckedProductsCount: 'rangeStockCheckedProductsCount',
			stockCheckedProductsCount: 'stockCheckedProductsCount',
			cancelledSubmissionIds: 'cancelledSubmissionIds',
			isPasswordEmpty: 'isPasswordEmpty',
			isHasStoreAddress: 'isHasStoreAddress',
			isHasStoreAddressDetail: 'isHasStoreAddressDetail',
			isHasStoreLocation: 'isHasStoreLocation',
			isExpired: 'isExpired',
			isAdmin: 'isAdmin',
			appName: 'appName',
			appProject: 'appProject',
			isUserCan: 'isUserCan',
		}),
		getTimeDifferents() {
			const startDate = new Date();
			const endDate = new Date(startDate);
			endDate.setDate(startDate.getDate() + 1);
			endDate.setHours(0, 0, 0, 0);

			const differenceInMilliseconds = endDate - startDate;
			return differenceInMilliseconds;
		},
		isNotAuthorizedPage() {
			const routePath = this.$route.path;
			const routeName = this.$route.name;
			const isHome = routePath === '/';
			const isLogin = routePath === '/login' || routePath === '/admin/login';
			const isRegister = (routePath === '/register' || routePath === '/register/supplier');
			const isSearch = routePath === '/search';
			const isPages = routePath.includes('/page');
			const isIndex = routePath === '/index.html';
			const isResetPassword = routePath === '/password/reset';
			const isAuthCallback = routePath === '/auth/callback';
			const isBillingRedirect = routePath === '/billings-redirect';
			const isProductDetail = routeName === 'product-detail';
			const isBrand = routePath === '/brand';
			const isDirect = routePath === '/direct';
			const isSupplierProducts = routePath.includes('/supplier');
			const isAllowed = isHome || isIndex || isLogin
							|| isResetPassword || isSearch || isRegister
							|| isAuthCallback || isPages || isBillingRedirect
							|| isProductDetail || isBrand || isDirect
							|| isSupplierProducts;
			return isAllowed;
		},
		isNavVisible() {
			if (this.$route.name === 'phoneVerification') return false;
			return !this.isAdminArea && (this.$route.path.indexOf('/auth/callback') === -1);
		},
		isRoutePageEditor() {
			return this.$route.name !== 'PageEditor';
		},
		billingsNoticeVisible() {
			const blaclistedRoutes = [
				'home',
				'wholesale-order',
				'wholesale-order-detail',
				'wholesale-order-checkout',
				'thank-you',
				'payment-confirmation',
				'payment-success',
				'phoneVerification',
			];
			return this.isRoutePageEditor && !blaclistedRoutes.includes(this.$route.name);
		},
		limitedStockNoticeVisible() {
			return this.isRoutePageEditor && this.isUserCan('product_view') && this.$route.name !== 'phoneVerification';
		},
		rangeStockCheckedNoticeVisible() {
			return this.isRoutePageEditor && this.isUserCan('product_view') && this.$route.name !== 'phoneVerification';
		},
		stockCheckedNoticeVisible() {
			return this.isRoutePageEditor && this.isUserCan('product_view') && this.$route.name !== 'phoneVerification';
		},
		emptyPasswordNoticeVisible() {
			return this.isRoutePageEditor && this.$route.name !== 'phoneVerification';
		},
		cancelledSubmissionNoticeVisible() {
			return this.isRoutePageEditor && this.$route.name !== 'phoneVerification';
		},
		emptyAddressNoticeVisible() {
			return this.isDropshipper && this.isRoutePageEditor && this.$route.name !== 'phoneVerification';
		},
		emptyAddressDetailNoticeVisible() {
			return this.isSupplier && this.isRoutePageEditor && this.$route.name !== 'phoneVerification';
		},
		emptyLocationNoticeVisible() {
			return this.isSupplier && this.isRoutePageEditor && this.$route.name !== 'phoneVerification';
		},
		currentAlert() {
			if (this.alerts.length === 0) return null;
			return this.alerts[this.currentAlertIndex];
		},
		isAdminArea() {
			return this.$route.path.includes('admin');
		},
		// Force OTP - Phone Verification
		emptyPhoneVerification() {
			if (this.$route.path.includes('phone-verification')) {
				return false;
			}
			if (!this.user) {
				return false;
			}
			// return !this.user.is_phone_verified; // TODO : Uncomment to activate
			return false;
		},
		redirectPage() {
			let path = '';
			let pathQuery = '';

			if (this.isExpired && !this.isSupplier) {
				return {
					redirectPath: path,
					pathQuery,
					currentPath: this.$route.path,
				};
			}

			if (this.emptyPhoneVerification) {
				path = '/phone-verification';
				if (this.$route.params.id) {
					path = `/phone-verification/${this.$route.params.id}`;
				}
				pathQuery = '';
			} else if (!this.isHasStoreAddress && this.emptyAddressNoticeVisible) {
				path = '/profile';
				pathQuery = '?tab=address';
			} else if (!this.isHasStoreAddressDetail && this.emptyAddressDetailNoticeVisible) {
				path = '/settings/store';
				pathQuery = '?to=information';
			} else if (!this.isHasStoreLocation && this.emptyLocationNoticeVisible) {
				path = '/settings/store';
				pathQuery = '?to=location';
			}
			return {
				redirectPath: path,
				pathQuery,
				currentPath: this.$route.path,
			};
		},
	},
	mounted() {
		this.triggerPopup();
		this.buildAlerts();
	},
	methods: {
		...mapActions({
			toggleAnnouncements: 'toggleAnnouncements',
			setCancelledSubmissionIds: 'setCancelledSubmissionIds',
			fetchUser: 'fetchUser',
		}),
		buildAlerts() {
			const alerts = [];

			// Expired Subscription Notice
			if (this.isExpired && !this.isSupplier) {
				alerts.push({
					type: 'Subscription',
					alertClass: 'alert-danger',
					message: 'Masa aktif subscription Ostock Anda telah berakhir. Harap lakukan pembayaran untuk mengaktifkan kembali akun Anda.',
					actionLabel: 'Bayar Sekarang',
					action: 'goToBillings',
				});
			}

			// Billings Notice
			if (this.billingsCount > 0 && this.billingsNoticeVisible) {
				alerts.push({
					type: 'Billing',
					alertClass: 'alert-danger',
					message: `Anda memiliki ${this.billingsCount} tagihan yang menunggu untuk dibayarkan`,
					actionLabel: 'Lihat Tagihan',
					action: 'goToBillings',
				});
			}

			// Limited Stock Notice
			if (this.limitedStockProductIds.length > 0 && this.limitedStockNoticeVisible) {
				alerts.push({
					type: 'Stok',
					alertClass: 'alert-danger',
					message: `Anda memiliki ${this.limitedStockProductIds.length} produk yang memiliki stock kurang dari atau sama dengan 10`,
					actionLabel: 'Lihat Produk',
					action: 'goToLimitedStockProducts',
				});
			}

			// Range Stock Checked Notice
			if (this.rangeStockCheckedProductsCount.length > 0 && this.rangeStockCheckedNoticeVisible) {
				this.rangeStockCheckedProductsCount.forEach((item) => {
					alerts.push({
						type: 'Stok',
						alertClass: 'alert-danger',
						message: `Terdapat ${item.count} produk yang stocknya kurang dari ${item.max_range}`,
						actionLabel: 'Lihat Produk',
						action: 'goToRangeStockCheckedProducts',
						actionData: item.max_range,
					});
				});
			}

			// Stock Checked Notice
			if (this.stockCheckedProductsCount > 0 && this.stockCheckedNoticeVisible) {
				alerts.push({
					type: 'Stok',
					alertClass: 'alert-danger',
					message: `Terdapat ${this.stockCheckedProductsCount} produk yang harus diupdate stocknya`,
					actionLabel: 'Lihat Produk',
					action: 'goToStockCheckedProducts',
				});
			}

			// Cancelled Submission Notice
			if (this.cancelledSubmissionIds.length > 0 && this.cancelledSubmissionNoticeVisible) {
				alerts.push({
					type: 'Order',
					alertClass: 'alert-danger',
					message: `Anda memiliki ${this.cancelledSubmissionIds.length} Order yang dibatalkan`,
					actionLabel: 'Lihat Order',
					action: 'goToCancelledSubmission',
				});
			}

			// Empty Password Notice
			if (this.isPasswordEmpty && this.emptyPasswordNoticeVisible) {
				alerts.push({
					type: 'Account',
					alertClass: 'alert-danger',
					message: 'Anda belum mengatur password. Harap masukkan password di halaman profile.',
					actionLabel: 'Lihat Profile',
					action: 'goToProfile',
				});
			}

			// Empty Address Notice
			if (!this.isHasStoreAddress && this.emptyAddressNoticeVisible) {
				alerts.push({
					type: 'Toko',
					alertClass: 'alert-warning',
					message: 'Anda belum mengatur alamat. Harap masukkan alamat di halaman profile.',
					actionLabel: 'Lihat Profile',
					action: 'goToProfileAddress',
				});
			}

			// Supplier Empty Address Detail Notice
			if (!this.isHasStoreAddressDetail && this.emptyAddressDetailNoticeVisible) {
				alerts.push({
					type: 'Toko',
					alertClass: 'alert-warning',
					message: 'Anda belum melengkapi alamat toko. Harap lengkapi alamat di halaman settings.',
					actionLabel: 'Lihat Settings',
					action: 'goToSettingsStore',
				});
			}

			// Empty Location Notice
			if (!this.isHasStoreLocation && this.emptyLocationNoticeVisible) {
				alerts.push({
					type: 'Toko',
					alertClass: 'alert-warning',
					message: 'Anda belum mengatur lokasi toko. Harap masukkan lokasi toko di halaman settings.',
					actionLabel: 'Lihat Settings',
					action: 'goToSettingsLocation',
				});
			}

			this.alerts = alerts;
		},
		handleAlertAction(alert) {
			const actionMap = {
				goToBillings: () => this.$router.push('/billings'),
				goToLimitedStockProducts: () => this.goToLimitedStockProducts(),
				goToRangeStockCheckedProducts: () => this.goToRangeStockCheckedProducts(alert.actionData),
				goToStockCheckedProducts: () => this.goToStockCheckedProducts(),
				goToCancelledSubmission: () => this.goToCancelledSubmission(),
				goToProfile: () => this.$router.push('/profile'),
				goToProfileAddress: () => this.$router.push('/profile?tab=address'),
				goToSettingsStore: () => this.$router.push('/settings/store'),
				goToSettingsLocation: () => this.$router.push('/settings/store?to=location'),
			};

			const action = actionMap[alert.action];
			if (action) {
				action();
			}
		},
		nextAlert() {
			if (this.alerts.length === 0) return;
			this.currentAlertIndex = (this.currentAlertIndex + 1) % this.alerts.length;
		},
		prevAlert() {
			if (this.alerts.length === 0) return;
			this.currentAlertIndex = this.currentAlertIndex === 0
				? this.alerts.length - 1
				: this.currentAlertIndex - 1;
		},
		goToLimitedStockProducts() {
			const productIdsString = this.limitedStockProductIds.join();
			this.$router.push(`/products?product_ids=${productIdsString}`);
		},
		goToRangeStockCheckedProducts(maxRange) {
			this.$router.push(`/products?range_stock=${maxRange}`);
		},
		goToStockCheckedProducts() {
			this.$router.push('/products?stock_checked=1');
		},
		goToCancelledSubmission() {
			const callback = () => {
				this.setCancelledSubmissionIds([]);
			};
			const callbackError = (error) => {
				console.log(error);
				this.$notify({
					group: 'app',
					title: 'Submission',
					text: 'Set Cancel Submission Readed',
					type: 'warn',
				});
			};
			submissionApi.cancelledNoticeReaded(callback, callbackError);
			const productIdsString = this.cancelledSubmissionIds.join();
			this.$router.push(`/orders?submission_ids=${productIdsString}`);
		},
		getDataPopupInformation() {
			// const today = dayjs().format('YYYY-MM-DD');
			const params = {
				// release_date: today,
			};
			const callback = (res) => {
				const informations = res?.data;
				let ownerType = duplicateVar(this.user?.owner_type);
				const roleSupplierTeams = ['owner_admin', 'owner_cs', 'owner_shipper'];
				if (this.user?.owner_type === 'dropshipper') {
					ownerType = 'seller';
				}

				if (roleSupplierTeams.includes(this.user?.role)) {
					ownerType = 'supplier';
				}
				const infoIds = duplicateVar(JSON.parse(getCookie(COOKIE_POPUP_CLOSED_IDS)) ?? []);
				if (infoIds.length === 0 || !infoIds || infoIds === null || infoIds === '') {
					setCookie(COOKIE_POPUP_CLOSED_IDS, JSON.stringify([]), this.getTimeDifferents, null, true);
				}

				this.informations = informations?.filter(info => info?.is_active && !infoIds?.includes(info?._id) && (info?.target === 'seler_supliers' || info?.target === ownerType));
				this.showPopupInformation();
			};
			const err = (e) => {
				console.log(e);
			};

			homepageApi.getDataPopupInformation(params, callback, err);
		},
		showPopupInformation(index = 0) {
			this.currentInformationIndex = index;
			if (this.informations.length > 0) {
				this.currentInformation = this.informations[this.currentInformationIndex];
				this.isModalVisible = true;
			}
		},
		closeModal() {
			const infoCookie = duplicateVar(JSON.parse(getCookie(COOKIE_POPUP_CLOSED_IDS)));
			infoCookie.push(this.currentInformation._id);
			setCookie(COOKIE_POPUP_CLOSED_IDS, JSON.stringify(infoCookie), this.getTimeDifferents, null, true);
			this.currentInformationIndex++;
			const config = this.informations[this.currentInformationIndex];

			this.isModalVisible = false;
			if (config) {
				this.isModalVisible = true;
				this.currentInformation = config;
			}
		},
		triggerPopup() {
			if (this.isLoggedIn) {
				const isOnBoarding = this.$route.path.includes('welcome');
				if (!isOnBoarding) {
					// this.fetchUser();
					this.getDataPopupInformation();
				}
			}
		},
	},
	watch: {
		user() {
			const slugExist = this.$route.params?.slug ?? null;
			if (this.isAdmin && slugExist !== null) {
				this.$router.push(`/admin/products/preview/${slugExist}`);
			} else if (this.isAdmin && !this.isSupplier && !this.isDropshipper) {
				this.$router.push('/admin');
			}
		},
		redirectPage: {
			handler(newValue) {
				if (!newValue.redirectPath) return;
				if (newValue.currentPath === newValue.redirectPath) return;
				this.$router.push({ path: `${newValue.redirectPath}${newValue.pathQuery}` });
			},
			deep: true,
			immediate: true,
		},
		alerts: {
			handler(newAlerts) {
				if (newAlerts.length > 0 && this.currentAlertIndex >= newAlerts.length) {
					this.currentAlertIndex = 0;
				}
			},
			immediate: true,
		},
		// Watch for changes in alert conditions
		isExpired() {
			this.buildAlerts();
		},
		billingsCount() {
			this.buildAlerts();
		},
		limitedStockProductIds() {
			this.buildAlerts();
		},
		rangeStockCheckedProductsCount() {
			this.buildAlerts();
		},
		stockCheckedProductsCount() {
			this.buildAlerts();
		},
		cancelledSubmissionIds() {
			this.buildAlerts();
		},
		isPasswordEmpty() {
			this.buildAlerts();
		},
		isHasStoreAddress() {
			this.buildAlerts();
		},
		isHasStoreAddressDetail() {
			this.buildAlerts();
		},
		isHasStoreLocation() {
			this.buildAlerts();
		},
		$route() {
			this.buildAlerts();
		},
	},
};
</script>
